<template>

    <div v-cloak class="container-fluid">

        <div class="row">
            <div class="col">
                <!-- compose message -->
                <div class="h4 mt-2 text-portal-soft-black" v-once>{{cmsContentBlocks['templateSelector.MainPage.Header']}}</div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <!-- Please choose the type of message you would like to compose. Messages are typically responded to within 2 business days. -->
                <div class="text-portal-soft-black" v-once>{{cmsContentBlocks['templateSelector.MainPage.2DayWarningSubHeader']}}</div>
                <b class="text-portal-secondary-red" v-once>{{cmsContentBlocks['templateSelector.MainPage.2DayWarningSubHeaderImportant']}}</b>
                <banner-component v-if="nonEnglish" :bannerText="cmsContentBlocks.messageMustBeInEnglish"></banner-component>
            </div>
        </div>

        <first-level-nav-component v-show="!selectedTemplate"
                                   :template-record-reference-data="templateReferenceData"
                                   :recently-used-templates="recentlyUsedTemplates"
                                   :cms-content-blocks="cmsContentBlocks"
                                   @templateClicked="firstLevelTemplateSelected"
                                   @recentClicked="recentClicked"></first-level-nav-component>

        <second-level-nav-component v-if="selectedTemplate"
                                    :selected-record="selectedTemplate"
                                    :cms-content-blocks="cmsContentBlocks"
                                    @eraseLevelOneSelection="eraseLevelOneSelection"
                                    @templateClicked="secondLevelTemplateSelected"></second-level-nav-component>

    </div>

</template>

<script>

    import Vue from 'vue';
    import firstLevelNavComponent from './template.selector.first.level.vue';
    import secondLevelNavComponent from './template.selector.second.level.vue';
    import mskBanner from '../../../../../vuecomponents/Banner/msk.banner.vue';
    import { MessageHttpSvc } from '@SharedHttpServices/message.httpservice';

    export default {
        name: 'composeMessageTemplateSelector',
        props: {

            //holds the nav menu configuration (NavigationMenuItem.cs)
            templateReferenceData: { type: Array },

            //{ department: ..., template: ...}
            recentlyUsedTemplates: { type: Array },

            cmsContentBlocks: {},

            nonEnglish: { type: Boolean }

        },
        components: {
            'first-level-nav-component': firstLevelNavComponent,
            'second-level-nav-component': secondLevelNavComponent,
            'banner-component': mskBanner
        },
        data: function () {
            return {

                //data we bind with. This is only in play when a nav with a 2nd level naviation is selected
                selectedTemplate: null
            }
        },
        methods: {

            firstLevelTemplateSelected: function (template) {

                //if we want to go straight to the template...then go to in now
                if (template.children.length == 0) {
                    this.$emit('templateSelected', template);
                    return;
                }

                this.selectedTemplate = template;
            },

            secondLevelTemplateSelected: function (template) {
                this.$emit('templateSelected', template);
                this.selectedTemplate = null;
            },

            recentClicked: function (record) {
                this.$emit('templateSelected', record);
            },

            eraseLevelOneSelection: function () {
                this.selectedTemplate = null;
            }

        }
    };
</script>

